<template>
  <transition name="fade">
    <main role="main" v-if="itemLoading === false">
      <meta-title :title="metaTitle"></meta-title>
      <section class="section section-default section-album">
        <div class="container m-container-only-s">
          <div class="row">
            <div class="col col-poster col-10 col-s-24">
              <figure>
                <img :src="replaceCoverImage(newContentData.cover)" alt="" />
              </figure>
            </div>
            <div class="col col-tracks col-14 col-s-24">
              <h1>{{ newContentData.actors }}</h1>
              <h2>
                {{ newContentData.title }}
                <span class="nowrap">
                  <a v-if="isBox"
                    href=""
                    style="color: red"
                    @click.prevent="toggleFavorites(newContentData)"
                  >
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="16"
                        cy="16"
                        r="16"
                        :fill="
                          !checkFavorites(newContentData.id)
                            ? '#acacac'
                            : '#f37920'
                        "
                      />
                      <path
                        d="M10 24L16 20.5L22 24V9.5C22 8.6875 21.3125 8 20.5 8H11.5C10.6562 8 10 8.6875 10 9.5V24Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                </span>
              </h2>
              <h3>{{ newContentData.year || "" }}</h3>
              <a
                href="#"
                v-if="tracks.length&&isBox"
                class="btn filled"
                @click.prevent="
                  toggleActive({ position: tracks[0].position, status: true })
                "
                >{{ $t("album.playAlbum") }}</a
              >

              <transition-group name="audio-list" class="tracks" tag="div">
                <Track
                  v-for="(item, index) in tracks"
                  :item="item"
                  :key="item.position"
                  :contentType="newContentData.contentType"
                  :active="
                    playList[index].active &&
                    newContentData.id === contentData.id
                  "
                  :time="playList[index].currentTime"
                  :index="index"
                  @active-change="toggleActive"
                />
              </transition-group>
            </div>
          </div>
        </div>
      </section>
    </main>
  </transition>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import cover from "@/mixins/cover";
import Track from "@/components/audio/Track";
// import utils from "@/lib/utils";
import audio from "@/mixins/audio";

export default {
  name: "AlbumInfo",
  title() {
    return this.$t("pages.album") + this.newContentData.title;
  },
  props: ["shuffle"],
  components: { Track },
  mixins: [cover, audio],
  data() {
    return {
      repeat: false,
    };
  },
  computed: {
    ...mapState("settings", {
      prevented: (state) => state.prevented,
	  isBox: state => state.isBox
    }),
    ...mapGetters("favorites", {
      checkFavorites: "CHECK_EXIST",
    }),
  },
  beforeRouteUpdate(to, from, next) {
    if (
      to.path.substring(0, 8) === "/albums/" &&
      to.path.substring(8) !== from.path.substring(8)
    ) {
      this.setEntityContent(["itemLoading", "empty"]);
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    this.setEntityContent(["itemLoading", "empty"]);
    next();
  },
  watch: {
    itemLoading: {
      handler() {
        if (this.itemLoading === "empty") {
          this.actionItem({ id: this.$route.params.id });
        }
      },
      immediate: true,
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions("audio", {
      actionItem: "item",
    }),
    ...mapActions({
      setLocale: "SET_LOCALE",
    }),
    ...mapActions("favorites", {
      toggleFavorites: "toggleEntity",
    }),
  },
};
</script>

<style scoped>
/deep/ .audio-list-move {
  transition: transform 1s;
}
</style>
